import React from 'react';
import { ContainerInfoMini } from '../../mini/index.styled';
import { ChooseWhere, PanAround } from '../../../../assets';

export const ContainerInfo = ({ onClick }) => (
  <ContainerInfoMini onClick={onClick}>
    <div>&nbsp;</div>

    <div>
      <img alt='pan-around' src={PanAround}></img>
      <div className='info-title'>PAN AROUND TO EXPLORE</div>
    </div>

    <div>
      <img alt='choose-where' src={ChooseWhere}></img>
      <div className='info-title'>CHOOSE WHERE TO GO NEXT</div>
    </div>

    <div className='info-tap'>TAP TO CONTINUE</div>
  </ContainerInfoMini>
)